import { useQuery } from "@tanstack/vue-query";
import { fetchWithAuth } from "../config/axios";

interface TeamMember {
    id: string;
    email: string;
    name: string;
    department: string;
    timeZone?: string;
    title?: string;
    status: string;
}

async function getTeam(): Promise<TeamMember[]> {
    const response = await fetchWithAuth.get<TeamMember[]>("/org/team");
    return response.data;
}

export function useTeam() {
    const {
        data: teamMembers,
        isLoading: loadingTeam,
        isError: teamError,
        refetch: reloadTeam,
    } = useQuery({
        queryKey: ["team"],
        queryFn: getTeam,
    });

    const employeeMailToName = (email: string): string => {
        if (!teamMembers.value) return email;
        const member = teamMembers.value.find((member) => member.email === email);
        return member?.name || email;
    };

    return {
        teamMembers,
        loadingTeam,
        teamError,
        reloadTeam,
        employeeMailToName,
    };
}
